// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"976a5ab5","239":"98c810e4","455":"9769f807"}[chunkId] + ".chunk.js";
};